import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm, getFormValues } from 'redux-form';
import * as validateRule from '../../validateRule';
import Conf from '../../../config/config.js';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    textAlign: 'center',
    flexDirection: 'column',
    marginTop: '100px',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '16px',
    width: '50%',
    backgroundColor: '#fafafa',
    minWidth: '300px',
  },
  button: {
    marginTop: '20px',
    width: '60%',
    maxWidth: '500px',
    minWidth: '200px',
  },
  card: {
    margin: '0px 0px 16px 0px',
    paddingTop: '10px',
    textAlign: 'center',
    backgroundColor: '#e8f0fe',
    height: "auto",
    minWidth: '260px'
  },
  cardh: {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
  },
  title: {
      color: "#000000",
      fontSize: "1.7em",
      fontWeight: 'bold',
  },
  textField: {
    width: '80%',
    maxWidth: '800px',
    minWidth: '240px',
  },
  typography: {
    color: "#000000",
    border: "solid 1px #000000",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.1em",
    fontSize: "1.0em",
    textAlign: "left",
  },
  typographySec: {
    color: "#d50000",
    border: "solid 1px #d50000",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.1em",
    fontSize: "1.0em",
    textAlign: "left",
  },
  typographyred: {
    color: "#d50000",
    fontSize: "1.0em",
    textAlign: "left",
  },
  typographyblack: {
    color: "#000000",
    fontSize: "1.0em",
    textAlign: "left",
  },
  noticeBox: {
    border: "2px solid #d50000",
    margin: '10px 0',
    padding: '10px',
    backgroundColor: "#ffffff",
    textAlign: "left",
  },
  redUnderline: {
    color: "#d50000",
    textDecoration: "underline",
    fontWeight: "bold",
  },
});

const renderTextField = ({
  input,
  label,
  meta: { touched, error, valid },
  ...custom
}) => (
  <TextField
    label={label}
    helperText={touched && error}
    error={touched && !valid}
    inputProps={{
      min: 1
    }}
    {...input}
    {...custom}
  />
);

class Login extends React.Component {

  doLogin = async() => {
    console.log("#######");
    const { loginAction } = this.props;
    if (true) { //バリデーションがOK
      try {
        const result = await loginAction();
        console.log("結果：" + result);
        if (result === 'OK') {
          // メニュー画面へ遷移
          this.props.history.push('/workMenu');
        }
        else if (result === 'NO_USER_ID') {
          const { doOpenDialog } = this.props;
          const dialog = {
            type: 'close', // '閉じる'のみ表示
            title: '',
            message: 'login.dialog.error.nouserid',
          };
          doOpenDialog(dialog);
        }
        else if (result === 'NO_LOGIN') {
          const { doOpenDialog } = this.props;
          const dialog = {
            type: 'close', // '閉じる'のみ表示
            title: '',
            message: 'login.dialog.error.input',
          };
          doOpenDialog(dialog);
        }
        else {
          const { doOpenDialog } = this.props;
          const dialog = {
            type: 'close', // '閉じる'のみ表示
            title: 'system.message.error.title',
            message: 'login.dialog.error.system',
          };
          doOpenDialog(dialog);
        }
      }
      catch (err) {
        console.log(`エラー: ${err}`);
        const { doOpenDialog } = this.props;
        const dialog = {
          type: 'close', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'login.dialog.error.system',
        };
        doOpenDialog(dialog);
      }
    }
  };

  doUserRegist = () => {
    console.log("#userPolicy画面に遷移#");
    this.props.history.push('/userPolicy');
  };

  doPasswordReset = () => {
    console.log("#passwordReset画面に遷移#");
    this.props.history.push('/passwordReset');
  };

  render() {
    const { classes, handleSubmit } = this.props;

    return (
      <div>
        <form noValidate autoComplete="off" className={classes.root}>
          <Card className={classes.card}>
            <CardHeader className={classes.cardh} classes={{title: classes.title}} title={<FormattedMessage id={'login.card.title'}/>} />
          </Card>
          {/* <div className={classes.noticeBox}>
            <span className={classes.redUnderline}>防護管取付サービス料金改定のお知らせ</span><br/>
            平素より格別のご愛顧を賜り、誠にありがとうございます。<br/>
            昨今の物価や人件費の上昇により、<span className={classes.redUnderline}>2025年12月1日</span>よりサービス料金の改定をさせていただきます。<br/>
            何卒ご理解賜りますようお願い申し上げます。<br/>
            なお、<span className={classes.redUnderline}>2025年11月30日</span>までの申込については、取付希望日が<span className={classes.redUnderline}>2025年12月26日</span>までを条件に改定前価格でのご案内とさせていただきます。<br/>
            <br/>
            <div style={{textAlign: 'right'}}>
            　<u style={{color:'rgba(255, 0, 0, 0.92)', cursor:'hand'}}>
                <a target="_blank" rel="noopener noreferrer" href={Conf.BILL_MODIFI_URL}>
                防護管取付サービス料金について
                </a>
              </u>
            </div>
          </div> */}
          <Grid container>
            <Grid item xs={12}>
              <Field
                id="username"
                name="username"
                label={<FormattedMessage id={'login.in.mailaddress'}/>}
                className={classes.textField}
                required={true}
                margin="normal"
                variant="outlined"
                component={renderTextField}
                autoComplete="username"
                type="text"
                validate={[
                  validateRule.required,
                  validateRule.minLength(6),
                  validateRule.maxLength(80),
                  validateRule.email,
                  validateRule.emailDomain
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                id="password"
                name="password"
                label={<FormattedMessage id={'login.in.password'}/>}
                type="password"
                className={classes.textField}
                required={true}
                margin="normal"
                variant="outlined"
                component={renderTextField}
                autoComplete="current-password"
                validate={[
                  validateRule.required,
                  validateRule.minLength(8),
                  validateRule.maxLength(32),
                  validateRule.password,
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={handleSubmit(this.doLogin)}
                variant="contained"
                color="primary"
                className={classes.button}
                size="large"
              >
                <span><FormattedMessage id={'login.btn.login'} /></span>
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={this.doPasswordReset}
                className={classes.button}>
                <u><FormattedMessage id={'login.btn.reissue'} /></u>
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={this.doUserRegist}
                variant="contained"
                color="primary"
                size="large"
                className={classes.button}
              >
                <span><FormattedMessage id={'login.btn.regist'} /></span>
              </Button>
            </Grid>
          </Grid>
          <div>
            <Typography variant="subtitle2" display="inline" className={classes.typography}>
              おしらせ<br/>
              ・2026年4月1日より防護管受付センターから「配電サポートセンター」へ名称変更いたします。<br/>
              <br/>
              ・防護管の取付けまでの期間は、取付範囲および見積金額をご承諾後2.3週間程度を要しますので<br/>
              　早期のお申込みをお願いいたします（官公庁等に申請が必要な場合は更に日数を要します）。
              <Typography  className={classes.typographyred}>
              <br/>
              注）防護管・防護シート・防護ネット・ジャバラ管は、接近して作業を行う際、注意喚起と接触事故を防ぐ目的として取り付けるものです。<br/>
              絶対に作業者が触れたり、工作物が接触しないように、現場責任者へお伝えください。
             </Typography>
            </Typography>
            {/* <Typography variant="subtitle2" display="inline" className={classes.typographySec}>
             <Typography  className={classes.typographyblack}>
             2025.11.19<br/>
             【年末年始休業のお知らせ】<br/>
              平素より当サービスをご利用いただき、誠にありがとうございます。<br/>
              誠に勝手ながら、以下の期間は年末年始休業とさせていただきます。<br/>
                <br/>
              【休業期間】<br/>
              2025年12月27日（土）～ 2026年1月4日（日）<br/>
                <br/>
              休業期間中にいただいたWEB受付（お問い合わせ・申込）につきましては、<br/>
              2026年1月5日（月）より順次対応させていただきます。
             </Typography>
            </Typography> */}
            <Typography variant="subtitle2" display="inline" className={classes.typographySec}>
             <Typography  className={classes.typographyblack}>
             【年末年始休業のお知らせ】<br/>
            <br/>
            平素より当サービスをご利用いただき、誠にありがとうございます。<br/>
            誠に勝手ながら、以下の期間は年末年始休業とさせていただきます。<br/>
            <br/>
            【休業期間】<br/>
            2026年12月29日（火）～ 2027年1月3日（日）<br/>
            <br/>
            休業期間中にいただいたWEB受付（お問い合わせ・申込）につきましては、<br/>
            2027年1月4日（月）より順次対応させていただきます。
             </Typography>
            </Typography>
            {/* <Typography variant="subtitle2" display="inline" className={classes.typographySec}>
             <Typography  className={classes.typographyblack}>
             2026.4.13<br/>
             ゴールデンウィークの時期が近づいてまいりました。<br/>
             ４月末から５月にかけて防護管取付を希望されるお客様は、余裕をもってお早めに<br/>
             お申込み頂きますようお願い申しあげます。
             </Typography>
            </Typography> */}
          </div>
        </form>
      </div>
    );
  }
}

const FORM_NAME = "Login";

Login.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

const mapStateToProps = state => ({
  initialValues: Conf.DefaultId ? {
    username:Conf.DefaultId,
    password:Conf.DefaultPassword
  }
  :
  {
    username: "",
    password: ""
  }
});

Login = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect(state => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Login));
export default withStyles(styles)(
  connect(
    mapStateToProps,
  )(Login)
);